
















































import Vue from 'vue'
import { mapState } from 'vuex'
import Component from 'vue-class-component'
import { ElButton } from 'element-ui/types/button'

import { CartItem, Product, SizeType, Page as IPage } from '@/interfaces/product'
import { dropbox } from '@/api/dropbox'
import { ElPopover } from 'element-ui/types/popover'

const BaseVue = Vue.extend({
  inheritAttrs: true,
  props: {
    page: Number,
    matchCurrentPage: Boolean
  },
  computed: {
    ...mapState([
      'sizeTypes',
      'products',
      'pages'
    ])
  }
})

@Component
export default class Page extends BaseVue {
  imageSrc = ''
  shownTooltip: boolean[] = []

  async created () {
    const pageIndex = this.page - 1
    const foundPage: IPage = this.pages.find((page: IPage) => page.Pagina === pageIndex)

    if (foundPage) {
      try {
        this.imageSrc = (await dropbox.filesGetTemporaryLink({ path: `/Paginas/${foundPage.Archivo}` })).link
      } catch (error) {
        console.log(`Error while getting /Paginas/${foundPage.Archivo}`)
      }
    }
  }

  formatPrice (price: number) {
    const formatter = new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })

    return formatter.format(price)
  }

  get pageProducts () {
    return this.matchCurrentPage
      ? this.products.filter((product: Product) => product.PAG === this.page - 1)
      : []
  }

  shouldShowTooltip (index: number) {
    const { popover }: { popover: ElPopover[] } = this.$refs as any

    if (!popover || !popover[index]) return false

    return (popover[index] as any).showPopper
  }

  async onProductSelect (product: CartItem, popoverButton: HTMLButtonElement) {
    this.$store.commit('addItem', product)
    popoverButton.click()
  }

  getBuyBtnStyle (coords: string) {
    if (!coords) return {}

    const [left, top] = coords.split(',')

    return {
      left: left.trim(),
      top: top.trim()
    }
  }

  getSizesTable (product: Product): CartItem[] {
    const sizes = this.getSizes(product.TipoTalla)

    return sizes.map(size => ({
      size: `Talla: ${size}`,
      fullSize: size,
      name: product.NombreCorto,
      color: product.Color,
      fullname: product.NombreLargo,
      quantity: 1,
      _orig: product
    }))
  }

  getSizes (sizeType: string): string[] {
    return (this.sizeTypes.find(({ Tipo }: SizeType) => Tipo === sizeType)?.Tallas ?? '').split(',')
  }
}
